module.exports = __webpack_public_path__ + "img/ic_qu_check_off.4e890cd5.svg";